export default {
  template: `
    <div :id="'d3vue-popover-' + id" :style="style" >
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut" >
        <div 
           v-if="show" 
           :class="['d3vue-popover', arrowPosition]" 
           @mouseenter="mouseEnter" 
           @mouseleave="mouseLeave" >
          <template v-if="text" >{{ text }}</template>
          <component v-else-if="component" :is="component" :data="data" ></component>
        </div>
      </transition>
    </div>
  `,
  props: {
    position: {
      type: String,
      default: 'top'
    }
  },
  data () {
    return {
      id: null,
      top: 0,
      left: 0,
      showPopover: false,
      popTimeout: null,
      captureEvents: false,
      parent: null,
      animation: null
    }
  },
  computed: {
    style () {
      return {
        'z-index': 9999,
        position: 'fixed',
        'z-index': '300',
        top: this.top + 'px',
        left: this.left + 'px',
        'pointer-events': this.captureEvents ? 'auto' : 'none'
      }
    },
    arrowPosition () {
      if (this.position === 'right') {
        return 'arrow-left'
      }
      if (this.position === 'left') {
        return 'arrow-right'
      }
      if (this.position === 'bottom') {
        return 'arrow-top'
      }
      return 'arrow-bottom'
    }
  },
  beforeDestroy () {
    if (this.animation) {
      cancelAnimationFrame(this.animation)
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (val) {
        if (val) {
          this.updatePosition()
        }
        else if (this.animation) {
          cancelAnimationFrame(this.animation)
        }
      }
    }
  },
  methods: {
    updatePosition () {
      if (this.parent) {
        const parentRect = 
        (() => {
          if (this.position === 'right') {
            return this.rightPosition
          }
          if (this.position === 'left') {
            return this.leftPosition
          }
          if (this.position === 'bottom') {
            return this.bottomPosition
          }
          return this.topPosition
        })()(
          this.parent.getBoundingClientRect(),
          this.$el ? this.$el.getBoundingClientRect() : {height: 0, width: 0}
        )
      }
      this.animation = requestAnimationFrame(this.updatePosition)
    },
    topPosition (parentRect, rect) {
      this.top = parentRect.y - rect.height - 5
      this.left = parentRect.x + parentRect.width / 2 - rect.width / 2
    },
    leftPosition (parentRect, rect) {
      this.top = parentRect.y + parentRect.height / 2 - rect.height / 2
      this.left = parentRect.x - rect.width - 5
    },
    rightPosition (parentRect, rect) {
      this.top = parentRect.y + parentRect.height / 2 - rect.height / 2
      this.left = parentRect.x + parentRect.width + 5
    },
    bottomPosition (parentRect, rect) {
      this.top = parentRect.y + rect.height + 5
      this.left = parentRect.x + parentRect.width / 2 - rect.width / 2
    },
    mouseEnter () {
      clearTimeout(this.popTimeout)
    },
    mouseLeave () {
      this.popTimeout = setTimeout(() => {
        this.showPopover = false
        this.captureEvents = false
      }, 500)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/d3vue/mixins/popover.js